import { Skeleton } from 'ui'

export const SkeletonComposition = () => {
  return (
    <div className='space-y-2'>
      <Skeleton className='h-4 w-[250px]' />
      <Skeleton className='h-4 w-[200px]' />
    </div>
  )
}
